import { render } from "./GoBackButton.vue?vue&type=template&id=1f8ff44d&ts=true"
import script from "./GoBackButton.vue?vue&type=script&lang=ts"
export * from "./GoBackButton.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__